import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sortedTaskBackgroundColor'
})
export class SortedTaskBackgroundColorPipe implements PipeTransform {
    transform(taskState: string) {
        if (taskState === 'Active') {
            return 'sorted-state-active';
        } else if (taskState === 'Te testen') {
            return 'sorted-state-to-test';
        } else if (taskState === 'New') {
            return 'sorted-state-new';
        } else if (taskState === 'On hold') {
            return 'sorted-state-on-hold';
        } else if (taskState === 'Backlog') {
            return 'sorted-state-backlog';
        } else if (taskState === 'Resolved') {
            return 'sorted-state-resolved';
        }
        return;
    }
}
